import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';

export default function TrustSection() {
  const { t } = useTranslation();
  
  const testimonials = [
    {
      nameKey: 'trust.testimonial1.name',
      roleKey: 'trust.testimonial1.role',
      contentKey: 'trust.testimonial1.content',
      rating: 5,
      avatar: 'SJ'
    },
    {
      nameKey: 'trust.testimonial2.name',
      roleKey: 'trust.testimonial2.role',
      contentKey: 'trust.testimonial2.content',
      rating: 5,
      avatar: 'MC'
    },
    {
      nameKey: 'trust.testimonial3.name',
      roleKey: 'trust.testimonial3.role',
      contentKey: 'trust.testimonial3.content',
      rating: 5,
      avatar: 'ER'
    }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('trust.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('trust.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="text-center">
              <div className="mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-lg">{testimonial.avatar}</span>
                </div>
                <div className="flex justify-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
              </div>
              <p className="text-gray-300 mb-6 italic">"{t(testimonial.contentKey)}"</p>
              <div>
                <div className="font-semibold text-white">{t(testimonial.nameKey)}</div>
                <div className="text-gray-400 text-sm">{t(testimonial.roleKey)}</div>
              </div>
            </Card>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="text-center">
          <div className="flex flex-col sm:flex-row sm:inline-flex items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 bg-gray-800 rounded-lg px-4 sm:px-8 py-6 sm:py-4 max-w-4xl mx-auto">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-green-400 text-2xl"></i>
              <span className="text-white font-medium">{t('trust.badge.licensed')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-lock-line text-blue-400 text-2xl"></i>
              <span className="text-white font-medium">{t('trust.badge.security')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-customer-service-2-line text-purple-400 text-2xl"></i>
              <span className="text-white font-medium">{t('trust.badge.support')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}